import { useEffect } from 'react'

const DynamicGoogleFont = ({
  fontFamily,
  weights,
}: {
  fontFamily: string
  weights: string[]
}) => {
  useEffect(() => {
    const url = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(/\s+/g, '+')}:${weights.join(',')}`
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.href = url
    document.head.appendChild(link)

    // Clean up: Remove the link tag when the component unmounts
    return () => {
      document.head.removeChild(link)
    }
  }, [fontFamily, weights])

  return null
}

export default DynamicGoogleFont
